import { initializeApp, getApps, getApp } from "firebase/app"
import { getAuth } from "firebase/auth"
import { initializeFirestore, getFirestore } from "firebase/firestore"
import { getStorage } from "firebase/storage"

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY || "AIzaSyDe0eefelND4TxsiDD3NnzQ5-cxL1NJvLU",
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN || "portal-kuliah.firebaseapp.com",
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID || "portal-kuliah",
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET || "portal-kuliah.firebasestorage.app",
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID || "631999216488",
  appId: import.meta.env.VITE_FIREBASE_APP_ID || "1:631999216488:web:679bc4ea1c27758ca9f4dd",
  measurementId: "G-B64M6NL2YK"
}

const app = getApps().length > 0 ? getApp() : initializeApp(firebaseConfig)

export const auth = getAuth(app)

let firestoreDb
try {
  firestoreDb = initializeFirestore(app, {
    experimentalForceLongPolling: true
  })
} catch (e) {
  firestoreDb = getFirestore(app)
}

export const db = firestoreDb
export const storage = getStorage(app)
export default app

